import React from 'react';
import { Instagram, Phone, Mail, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A0A0A] border-t border-[#7FD4D4]/20 pt-16 pb-8" data-id="element-27">
      <div className="container mx-auto px-4 md:px-6" data-id="element-28">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-29">
          {/* Brand */}
          <div data-id="element-30">
            <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/256c3bfe-e89b-48e5-8016-7d66ea76ce60/capstone-mobile-detailing-2025.png.webp" alt="Capstone Mobile Detailing" className="h-10 w-auto object-contain mb-6" data-id="element-31" />
            <p className="text-white/60 mb-6 font-inter" data-id="element-32">
              Luxury Clean. Ultimate Convenience. <br data-id="element-33" />
              Phoenix's premier mobile detailing service.
            </p>
            <div className="flex space-x-4" data-id="element-34">
              <a href="#" className="text-white/60 hover:text-[#7FD4D4] transition-colors" data-id="element-35">
                <Instagram size={24} data-id="element-36" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-37">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-38">
              Services
            </h4>
            <ul className="space-y-3" data-id="element-39">
              {['Car Detailing', 'RV Detailing', 'Boat Detailing', 'Aircraft Detailing', 'Motorcycle Detailing', 'Fleet Detailing', 'Ceramic Coating'].map(item => <li key={item} data-id="element-40">
                  <a href="#" className="text-white/60 hover:text-[#7FD4D4] transition-colors text-sm" data-id="element-41">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-42">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-43">
              Company
            </h4>
            <ul className="space-y-3" data-id="element-44">
              {['About Us', 'Pricing', 'Booking', 'Contact Us', 'Terms of Service', 'Privacy Policy'].map(item => <li key={item} data-id="element-45">
                  <a href="#" className="text-white/60 hover:text-[#7FD4D4] transition-colors text-sm" data-id="element-46">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-47">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-48">
              Contact
            </h4>
            <ul className="space-y-4" data-id="element-49">
              <li className="flex items-start text-white/60 text-sm" data-id="element-50">
                <Phone size={16} className="mr-3 text-[#7FD4D4] mt-0.5" data-id="element-51" />
                <a href="tel:602-641-5089" className="hover:text-white transition-colors" data-id="element-52">
                  602-641-5089
                </a>
              </li>
              <li className="flex items-start text-white/60 text-sm" data-id="element-53">
                <Mail size={16} className="mr-3 text-[#7FD4D4] mt-0.5" data-id="element-54" />
                <a href="mailto:info@capstonedetailing.com" className="hover:text-white transition-colors" data-id="element-55">
                  info@capstonedetailing.com
                </a>
              </li>
              <li className="flex items-start text-white/60 text-sm" data-id="element-56">
                <MapPin size={16} className="mr-3 text-[#7FD4D4] mt-0.5" data-id="element-57" />
                <span data-id="element-58">Phoenix, AZ & Surrounding Valley</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-white/40" data-id="element-59">
          <p data-id="element-60">&copy; 2025 Capstone Mobile Detailing. All rights reserved.</p>
          <div className="mt-4 md:mt-0" data-id="element-61">
            <span className="mr-4" data-id="element-62">Phoenix, AZ</span>
            <span data-id="element-63">Made with ❤️ in Arizona</span>
          </div>
        </div>
      </div>
    </footer>;
}